import { useEffect, type ReactElement } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { API_URL } from '../lib/api';

/**
 * Einstiegspunkt eines Werbelinks (/einladung/ABC123).
 *
 * Meldet den Klick beim Backend, das daraufhin ein Cookie mit 60 Tagen
 * Laufzeit setzt. Dadurch wird auch zugeordnet, wer heute klickt und sich
 * erst Tage spaeter registriert — der Code in der URL waere dann laengst weg.
 *
 * Danach geht es zur Registrierung, mit dem Code zusaetzlich als Parameter
 * (doppelt haelt besser: falls das Cookie blockiert ist, greift der Parameter).
 */
export default function Einladung(): ReactElement {
  const { code } = useParams<{ code: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    const sauber = (code ?? '').trim().toUpperCase();
    const weiter = () =>
      navigate(sauber ? `/register?ref=${encodeURIComponent(sauber)}` : '/register', {
        replace: true,
      });

    if (!sauber) {
      weiter();
      return;
    }

    // credentials: 'include', damit das Cookie gesetzt werden darf.
    fetch(`${API_URL}/referrals/klick/${encodeURIComponent(sauber)}`, {
      credentials: 'include',
    })
      .catch(() => undefined) // Ein Netzfehler darf den Interessenten nicht aufhalten.
      .finally(weiter);
  }, [code, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 dark:bg-gray-900">
      <p className="text-sm text-gray-500 dark:text-gray-400">Einen Moment …</p>
    </div>
  );
}
